import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { SvgLineIntersectionJoin, SecondaryBtn } from '@tmapy/style-guide';
import { actionActivateJoinLineTool, actionDeactivateTools } from '../actions';
export const JoinLineToolBtn = ({ isActive, dispatch, children, }) => {
    const handleClick = useCallback(() => {
        if (isActive) {
            dispatch(actionDeactivateTools());
        }
        else {
            dispatch(actionActivateJoinLineTool());
        }
    }, [dispatch, isActive]);
    return (_jsx(SecondaryBtn, { icon: { element: _jsx(SvgLineIntersectionJoin, {}) }, isActive: isActive, tooltip: children, onClick: handleClick }));
};
//# sourceMappingURL=JoinLineToolBtn.js.map